import { Injectable } from '@angular/core';
import { Http, Response, Headers, } from "@angular/http";
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { catchError, map, tap } from 'rxjs/operators';
import { CONFIGURATION } from './app.config';

@Injectable()
export class AuthService {
  private _apiUrl = CONFIGURATION.baseAuthURL;
  constructor(private _http: Http) { }

  addUser(oLogin: object): Observable<any> {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    return this._http.post(this._apiUrl + '/register', oLogin, { headers: headers })
      .pipe(map((res: Response) => res.json()));
  }

  getUsers(data:any): Observable<any> {
    return this._http.post(this._apiUrl + '/users-list', data)
      .map((response: Response) => response.json())
      .catch(this.handleError);
  }

  updateUser(reqObj: any, ): Observable<any> {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    const id = typeof reqObj === 'number' ? reqObj : reqObj.userId;
    const url = `${this._apiUrl + '/update-user'}`;
    return this._http.put(url, reqObj, { headers: headers })
      .map((res: Response) => res.json())
      .catch(this.handleError);
  }

  referenceData(): Observable<any> {
    return this._http.get(this._apiUrl + '/reference-data')
      .map((response: Response) => response.json())
      .catch(this.handleError);
  }

  /** DELETE: delete the user from the server */
  deleteUser(id: any): Observable<any> {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    const url = `${this._apiUrl + '/delete-user'}/${id}`;

    return this._http.delete(url, { headers: headers })
  }
  resend(id: any): Observable<any> {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
   const body = { id };
  return this._http.put(this._apiUrl + '/resend-invite', id, { headers: headers })    .pipe(map((res: Response) => res.json())); }

  log(arg0: string): void {
    throw new Error("Method not implemented.");
  }

  private handleError(error: Response) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    console.error(error);
    return Observable.throw(error.json().error || 'Failed in web api(Server error) ');
  }
}



// WEBPACK FOOTER //
// ./src/app/auth.service.ts